<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="customer.no" placeholder="business.label.customerNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="customer.name" placeholder="business.label.customerName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="contactInfo.company" placeholder="business.label.company" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="contactInfo.contactor" placeholder="business.label.contactMan" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="contactInfo.phone" placeholder="business.label.phone" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="contactInfo.email" placeholder="business.label.email" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="contactInfo.idType" :options="idTypes" placeholder="business.label.idType" @change="refresh"/>
        <vxe-input v-model="contactInfo.idNumber" placeholder="business.label.idNumber" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.country" placeholder="business.label.country" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.province" placeholder="business.label.province" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.city" placeholder="business.label.city" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.district" placeholder="business.label.district" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.town" placeholder="business.label.town" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.village" placeholder="business.label.village" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.street" placeholder="business.label.street" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.postalCode" placeholder="business.label.postalCode" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.detailAddress" placeholder="business.label.detailAddress" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="direction.name" title="business.label.direction" width="80"/>
        <vxe-column field="contactInfo.company" title="business.label.company" width="80"/>
        <vxe-column field="contactInfo.contactor" title="business.label.contactor" width="80"/>
        <vxe-column field="contactInfo.phone" title="business.label.phone" width="80"/>
        <vxe-column field="contactInfo.email" title="business.label.email" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:idTypes}" field="contactInfo.idType" title="business.label.idType" width="80"/>
        <vxe-column field="contactInfo.idNumber" title="business.label.idNumber" width="80"/>
        <vxe-column field="addressInfo.country" title="business.label.country" width="80"/>
        <vxe-column field="addressInfo.province" title="business.label.province" width="80"/>
        <vxe-column field="addressInfo.city" title="business.label.city" width="80"/>
        <vxe-column field="addressInfo.district" title="business.label.district" width="80"/>
        <vxe-column field="addressInfo.town" title="business.label.town" width="80"/>
        <vxe-column field="addressInfo.village" title="business.label.village" width="80"/>
        <vxe-column field="addressInfo.street" title="business.label.street" width="80"/>
        <vxe-column field="addressInfo.postalCode" title="business.label.postalCode" width="80"/>
        <vxe-column field="addressInfo.detailAddress" title="business.label.detailAddress"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="addressInfo.defaults" title="business.label.defaults" width="60"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="copy(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <AddressEditor ref="editor" :directions="directions" :id-types="idTypes" @success="refresh"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import { Address } from '@/api/dto/common/Address'
import { Party } from '@/api/dto/common/Party'
import { ContactInfo } from '@/api/dto/valueobject/ContactInfo'
import { AddressInfo } from '@/api/dto/valueobject/AddressInfo'
import AddressEditor from '@/views/basedata/address/AddressEditor.vue'
import { getDictionaries } from '@/utils/util'

export default {
  name: 'AddressManagement',
  components: { AddressEditor },
  data() {
    return {
      loading: false,
      list: [],
      directions: [],
      idTypes: [
        { label: '身份证', value: '1' },
        { label: '军官证', value: '2' },
        { label: '护照', value: '3' },
        { label: '其他', value: '4' }
      ],
      page: 1,
      size: 20,
      contentSize: 0,
      customer: new Party(),
      contactInfo: new ContactInfo(),
      addressInfo: new AddressInfo()
    }
  },
  created() {
    getDictionaries('DIRECTION').then(result => {
      this.directions = result
    })
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('addressFactory', { 'customer.no': this.customer.no, 'customer.name': this.customer.name, contactInfo: this.contactInfo, addressInfo: this.addressInfo }, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.list = res.result.map(item => {
            return new Address(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.customer = new Party()
      this.contactInfo = new ContactInfo()
      this.addressInfo = new AddressInfo()
    },
    add() {
      this.$refs.editor.add()
    },
    edit(row) {
      this.$refs.editor.edit(row.id, false)
    },
    copy(row) {
      this.$refs.editor.edit(row.id, true)
    }
  }
}
</script>